import React, { useMemo } from 'react'

import ProductCardItem from '../ProductCardItem'

import { Brands } from '../../utils/Brands'

import { IZoomModal } from '../../page/Products'

import { Container } from './styles'

interface IProductsCardListProps {
    products: {
        items: {
            images: {
                imageUrl: string;
            }[]

            sellers: {
                sellerName: string;
                commertialOffer: {
                    Price: number
                    ListPrice: number;
                    AvailableQuantity: number;
                };
            }[]
        }[];
        linkText: string;
        productName: string;
        productReference: string;
    }[];
    currentBrand: string;
    amountItems: number;
    shouldUseNewTag: boolean;
    shouldShowButton?: boolean;
    textColor?: string;
    priceColor?: string;
    onGetInformationZoomModal?: (data: IZoomModal) => void;
    onOpenZoomModal?: () => void;
    sellerCode: string;
    wishlistId?: string;
}


const ProductsCardList: React.FC<IProductsCardListProps> = ({
    products,
    currentBrand,
    amountItems,
    shouldUseNewTag,
    shouldShowButton,
    textColor,
    priceColor,
    onGetInformationZoomModal,
    onOpenZoomModal,
    sellerCode,
    wishlistId,
}) => {

    const treatedUrlToBrandEcommerceMemo = useMemo(() => Brands.find((projectBrand) => projectBrand.vtexName === currentBrand)?.baseUrl, [currentBrand])

    return (
        <Container amountItems={amountItems}>
            {
                products.map((product) => (
                    <ProductCardItem
                        key={product.productReference + Math.random()}
                        shouldUseNewTag={shouldUseNewTag}
                        shouldShowButton={shouldShowButton}
                        brandBaseUrl={treatedUrlToBrandEcommerceMemo}
                        onGetInformationZoomModal={onGetInformationZoomModal}
                        onOpenZoomModal={onOpenZoomModal}
                        textColor={textColor}
                        priceColor={priceColor}
                        sellerCode={sellerCode}
                        wishlistId={wishlistId}
                        currentBrand={currentBrand}
                        {...product} />
                ))
            }
        </Container>
    )
}

export default ProductsCardList